import dayjs from 'dayjs'

import {
  generateAvatarUrl,
  generateCompanyName,
  generateDepartment,
  generateProductName,
  getRandomFloat,
} from '../utils/randomizer'

export const appRoutes = {
  'POST /app/:store/info/detailed': (params, config) => {
    const trackIds = JSON.parse(config.data)
    if (!Array.isArray(trackIds) || !trackIds.length)
      throw new Error('Missing trackId list')

    return {
      success: true,
      data: trackIds.map(trackId => ({
        trackId,
        categoryId: 36,
        categoryName: generateDepartment(),
        iconUrl: generateAvatarUrl(),
        name: generateProductName(),
        developerId: getRandomFloat(10_0000, 90_0000, 0),
        developerName: generateCompanyName(),
        priceValue: 0,
        price: '$0.00',
        rating: getRandomFloat(1, 5, 2),
        ratingCount: getRandomFloat(10_0000, 90_0000, 0),
        similarApps: Array.from({ length: 10 }, () => getRandomFloat(10_0000, 90_0000, 0)),
      })),
    }
  },
  'POST /app/info/simple/:store/country/:countryCode': (_params, config) => {
    const trackIds = JSON.parse(config.data)
    if (!Array.isArray(trackIds) || !trackIds.length)
      throw new Error('Missing trackId list')

    return {
      success: true,
      data: trackIds.map(trackId => ({
        trackId,
        categoryId: 36,
        categoryName: generateDepartment(),
        iconUrl: generateAvatarUrl(),
        name: generateProductName(),
        priceValue: 0,
        price: '$0.00',
        rating: getRandomFloat(1, 5, 2),
        ratingCount: getRandomFloat(10_0000, 90_0000, 0),
      })),
    }
  },
  'GET /app/:trackId/visibility-score/history': (params, config) => {
    const { trackId } = params
    const { countries, startDate, endDate } = config.params
    if (!trackId)
      throw new Error('Missing trackId')

    const dateRange = []
    const diff = dayjs(endDate).diff(startDate, 'day')
    for (let i = 0; i <= diff; i++) {
      dateRange.push(dayjs(startDate).add(i, 'day').format('YYYY-MM-DD'))
    }

    return {
      success: true,
      data: {
        trackId,
        scores: countries.reduce((acc, countryCode) => {
          acc[countryCode] = dateRange.map(date => ({
            date,
            score: getRandomFloat(0, 100, 3),
          }))
          return acc
        }, {}),
      },
    }
  },
}
